<template>
  <div id="app">
    <a
      class="skip-link"
      href="#main-content"
    >跳转到主要内容</a>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  min-height: 100vh;
  font-family: "PingFang SC", "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*margin-top: 60px;*/
}
.skip-link {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 10000;
  padding: 8px 14px;
  color: #fff;
  background: #1269d3;
  border-radius: 6px;
  transform: translateY(-160%);
  transition: transform .2s ease;
}
.skip-link:focus { transform: translateY(0); }
:focus-visible { outline: 3px solid #16b9c8; outline-offset: 3px; }
.flex{
  display: flex;
}
.banner-content{
  max-width: 1200px;
  
  text-align: left;
}
</style>
